import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getPowerGenerationSourceList,
	addNewPowerGenerationSource,
	updatePowerGenerationSource,
	deletePowerGenerationSource,
	getPowerGenerationSource,
} from '../powerGenerationSource/thunk';

export const initialState = {
	itemPowerGenerationSourceList: [],
	itemPowerGenerationSourceDetail: null,
	isPowerGenerationSourceLoading: false,
	isPowerGenerationSourceSuccess: false,


	powerGenerationSourceList: [],
	powerGenerationSourceListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,

	isLoading: false,
	isSuccess: false,
	isError: false,
	error: ""
};

const PowerGenerationSourceSlice = createSlice({
	name: 'PowerGenerationSource',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getPowerGenerationSource.fulfilled, (state, action) => {
			state.isPowerGenerationSourceLoading = false;
			state.isPowerGenerationSourceSuccess = true;
			state.itemPowerGenerationSourceDetail = action.payload;
			state.isLoadingList = false;

			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getPowerGenerationSource.pending, state => {
			state.isPowerGenerationSourceLoading = true;
			state.isPowerGenerationSourceSuccess = null;
			state.error = null;
			state.isLoadingList = true;

			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getPowerGenerationSource.rejected, (state, action) => {
			state.isPowerGenerationSourceLoading = false;
			state.isPowerGenerationSourceSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;

			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getPowerGenerationSourceList.pending, state => {
			state.isPowerGenerationSourceSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getPowerGenerationSourceList.fulfilled, (state, action) => {
			state.itemPowerGenerationSourceList = action.payload;
			state.powerGenerationSourceList = action.payload;
			state.isLoadingList = false;
			state.isPowerGenerationSourceSuccess = true;

			// Validar si el payload es un arreglo antes de usar .map
			if (Array.isArray(action.payload)) {
				let powerGenerationSourceListSelect = action.payload.map(item => ({
					item: item,
					value: item._id,
					label: item.name,
				}));

				state.powerGenerationSourceListSelect = powerGenerationSourceListSelect;
			} else {
				state.itemPowerGenerationSourceDetail = action.payload
				state.powerGenerationSourceListSelect = [];
			}
		});

		builder.addCase(getPowerGenerationSourceList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isPowerGenerationSourceSuccess = true;
		});
		builder.addCase(addNewPowerGenerationSource.fulfilled, (state, action) => {
			state.itemPowerGenerationSourceList.push(action.payload);
			state.powerGenerationSourceList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewPowerGenerationSource.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewPowerGenerationSource.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updatePowerGenerationSource.fulfilled, (state, action) => {
			state.itemPowerGenerationSourceList = state.itemPowerGenerationSourceList.map(powerGenerationSource =>
				powerGenerationSource.powerGenerationSourcename === action.payload.old_powerGenerationSource
					? { ...powerGenerationSource, ...action.payload.updated_powerGenerationSource }
					: powerGenerationSource
			);
			state.powerGenerationSourceList = state.powerGenerationSourceList.map(powerGenerationSource =>
				powerGenerationSource._id.toString() === action.payload._id.toString()
					? { ...powerGenerationSource, ...action.payload }
					: powerGenerationSource
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updatePowerGenerationSource.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updatePowerGenerationSource.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deletePowerGenerationSource.fulfilled, (state, action) => {
			state.itemPowerGenerationSourceList = current(state.itemPowerGenerationSourceList).filter(
				item => item._id !== action.payload._id
			);
			state.powerGenerationSourceList = current(state.powerGenerationSourceList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deletePowerGenerationSource.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deletePowerGenerationSource.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});

	},
});

export const { setRequireCloseModal } = PowerGenerationSourceSlice.actions;

export default PowerGenerationSourceSlice.reducer;
